import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, mergeProps as _mergeProps, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5139ceb2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "Inner relative grid p-24 text-desktop-cap text-center" };
const _hoisted_2 = { class: "Title" };
const _hoisted_3 = { class: "Body" };
const _hoisted_4 = {
    key: 0,
    class: "Media float-left w-144 mr-20 mb-16"
};
const _hoisted_5 = { class: "Description grow shrink basis-0 w-full max-w-full" };
const _hoisted_6 = {
    key: 0,
    class: "text-balance"
};
const _hoisted_7 = { class: "Date flex-1" };
const _hoisted_8 = { class: "Place flex-1" };
import { computed } from "vue";
import frames from "@/utils/frameToTime";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UICard',
    props: {
        title: {},
        description: {},
        place: {},
        date: {},
        caption: {},
        image: {},
        video: {},
        reverse: { type: Boolean },
        theme: { default: "accent" },
        folded: { type: [String, Boolean], default: true },
        delay: { default: 0 }
    },
    setup(__props) {
        const props = __props;
        const isFolded = computed(() => !!props.folded);
        const foldSide = computed(() => typeof props.folded === "string" ? props.folded : "left");
        return (_ctx, _cache) => {
            const _component_UIIcon = _resolveComponent("UIIcon");
            const _component_UIMaskReveal = _resolveComponent("UIMaskReveal");
            const _component_UIVideo = _resolveComponent("UIVideo");
            const _component_UIImage = _resolveComponent("UIImage");
            const _component_UIDogEared = _resolveComponent("UIDogEared");
            return (_openBlock(), _createBlock(_component_UIDogEared, {
                class: _normalizeClass(["UICard flex", { 'UICard--reverse': _ctx.reverse }]),
                folded: isFolded.value,
                side: foldSide.value,
                theme: _ctx.theme,
                delay: _ctx.delay
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (!_ctx.reverse)
                            ? (_openBlock(), _createBlock(_component_UIIcon, {
                                key: 0,
                                class: "Icon place-self-center text-32",
                                name: "symbol"
                            }))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_UIMaskReveal, {
                                as: "h3",
                                class: "text-mobile-title text-desktop-subtitle-1 text-balance",
                                delay: _ctx.delay + _unref(frames)(_ctx.reverse ? 20 : 0)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.title), 1)
                                ]),
                                _: 1
                            }, 8, ["delay"])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            (props.video || props.image)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    (props.video)
                                        ? (_openBlock(), _createBlock(_component_UIVideo, _normalizeProps(_mergeProps({ key: 0 }, props.video)), null, 16))
                                        : (_openBlock(), _createBlock(_component_UIImage, _normalizeProps(_mergeProps({ key: 1 }, props.image)), null, 16))
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_UIMaskReveal, {
                                    as: "p",
                                    class: "lg:text-desktop-body text-pretty whitespace-pre-line",
                                    delay: _ctx.delay + _unref(frames)(10)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.description), 1)
                                    ]),
                                    _: 1
                                }, 8, ["delay"])
                            ])
                        ]),
                        _createVNode(_component_UIMaskReveal, {
                            class: "Caption flex justify-center items-center gap-x-16 gap-y-2",
                            delay: _ctx.delay + _unref(frames)(_ctx.reverse ? 0 : 20)
                        }, {
                            default: _withCtx(() => [
                                (_ctx.caption)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.caption), 1))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.date), 1),
                                        _createVNode(_component_UIIcon, {
                                            class: "Icon text-32",
                                            name: "symbol"
                                        }),
                                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.place), 1)
                                    ], 64))
                            ]),
                            _: 1
                        }, 8, ["delay"])
                    ])
                ]),
                _: 1
            }, 8, ["folded", "side", "class", "theme", "delay"]));
        };
    }
});
